"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavigation = exports.NavigationProvider = void 0;
var react_1 = require("react");
var NavigationContext = react_1.createContext({
    navigate: function (path) { return console.log('Navigate to:', path); },
});
exports.NavigationProvider = NavigationContext.Provider;
var useNavigation = function () { return react_1.useContext(NavigationContext); };
exports.useNavigation = useNavigation;
